<script setup>
import {Link, usePage} from "@inertiajs/inertia-vue3";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import {computed} from "vue";
import {useHelpers, useTenantTextRules} from "@/helpers";

const currentUser = usePage().props.value.auth.user;
const helpers = useHelpers();
const { resolveTextRule } = useTenantTextRules();
const projectsButtonLabel = computed(() =>
  resolveTextRule('project.navigation.projects_button', 'Projects', 'project.navigation.projects_button')
);
const closedProjectsButtonLabel = computed(() =>
  resolveTextRule('project.navigation.closed_projects_button', 'Closed Projects', 'project.navigation.closed_projects_button')
);
const purchaseOrdersButtonLabel = computed(() =>
  resolveTextRule('project.navigation.purchase_orders_button', 'Purchase Orders', 'project.navigation.purchase_orders_button')
);
const closedPurchaseOrdersButtonLabel = computed(() =>
  resolveTextRule('project.navigation.closed_purchase_orders_button', 'Closed Purchase Orders', 'project.navigation.closed_purchase_orders_button')
);
</script>

<template>
  <Link :href="route('admin.projects.closed.index')" class="w-full mr-1"
        v-if="helpers.userCanManageProject(currentUser) && helpers.userHasPermission(currentUser, 'project_management')">
    <SecondaryButton :is-active="route().current('admin.projects.closed.index')">{{ closedProjectsButtonLabel }}
    </SecondaryButton>
  </Link>
  <Link :href="route('admin.projects.index')" class="w-full mr-1"
        v-if="helpers.userHasPermission(currentUser, 'project_management')">
    <SecondaryButton :is-active="route().current('admin.projects.index')">{{ projectsButtonLabel }}</SecondaryButton>
  </Link>
  <Link :href="route('admin.purchase-orders.index')" class="w-full mr-1"
        v-if="helpers.userHasPermission(currentUser, 'purchase_order')">
    <SecondaryButton :is-active="route().current('admin.purchase-orders.index')">{{ purchaseOrdersButtonLabel }}</SecondaryButton>
  </Link>
  <Link :href="route('admin.purchase-orders.closed.index')" class="w-full"
        v-if="helpers.userCanManageProject(currentUser) && helpers.userHasPermission(currentUser, 'purchase_order')">
    <SecondaryButton :is-active="route().current('admin.purchase-orders.closed.index')">{{ closedPurchaseOrdersButtonLabel }}
    </SecondaryButton>
  </Link>
</template>

<style scoped>

</style>
